import { ActualizacionViewModel } from '../models/actualizacion-datos.viewmodel';
import { ActualizacionExcelVM } from '../models/export/actualizacion-excel.vm';
import { mapDocumentType } from './document-type.map';

export function mapActualizacionToExcelVM(
  a: ActualizacionViewModel
): ActualizacionExcelVM {

  return {
    // === Identificación / Cuenta ===
    CUENTA: a.NumeroCuenta ?? '',
    IND_ACT_DATOS_CLIENTE: 'S',
    IND_ACT_DATOS_CONTACTO: 'S',
    PROCESO: '3308',
    MEDIO_SOLICITUD: 'V',
    CLASIFICACION: '1',
    DETALLE_CLASIFICACION: '',

    TIPO_SOLICITANTE: '1',
    CLASE_SOLICITANTE: '',
    TIPO_PERSONA_SOLICITANTE: '',
    TIPO_DOCUMENTO_SOLICITANTE: mapDocumentType(a.TipoDoc), //12-Tarjeta de identidad 13-Cédula de Ciudadanía 21-Tarjeta de Extranjería 22-Cédula de Extranjería 31-Número de Identificación Tributaria 41-Pasaporte 
    // 90-Tipo no definido
    NUMERO_DOCUMENTO_SOLICITANTE: a.Identificacion ?? '',
    EXPEDICION_DOCUMENTO_SOLICITANTE: a.LugarExpDoc?.toUpperCase() ?? '',
    NOMBRE_1_SOLICITANTE: a.Nombre?.toUpperCase() ?? '',
    NOMBRE_2_SOLICITANTE: a.Nombre1?.toUpperCase() ?? '',
    APELLIDO_1_SOLICITANTE: a.Apellido?.toUpperCase() ?? '',
    APELLIDO_2_SOLICITANTE: a.Apellido1?.toUpperCase() ?? '',
    RAZON_SOCIAL_SOLICITANTE_APLICA_PARA_NIT: a.RazonSoc?.toUpperCase() ?? '',
    TELEFONO_CONTACTO_SOLICITANTE: a.Telefono ?? '',
    CELULAR_SOLICITANTE: a.Celular ?? '',
    DIRECCION_SOLICITANTE: a.Direccion?.toUpperCase() ?? '',
    INF_ADICIONAL_DIRECCION_SOLICITANTE: '',
    DEPARTAMENTO_SOLICITANTE: a.DeptoCod ?? '',
    MUNICIPIO_SOLICITANTE: a.MunCod ?? '',
    BARRIO_SOLICITANTE: '',
    EMAIL_SOLICITANTE: a.Correo?.toUpperCase() ?? '',
    MEDIO_NOTIFICACION: '',
    RADICADO: '',
    TIPO_TRAMITE: '6',
    TIPO_RTA: '51',
    OBSERVACION: '',

    TIPO_PERSONA_CLIENTE: '',
    TIPO_DOCUMENTO_CLIENTE: '',
    NUMERO_DOCUMENTO_CLIENTE: '',
    NOMBRE_1_CLIENTE: '',
    NOMBRE_2_CLIENTE: '',
    APELLIDO_1_CLIENTE: '',
    APELLIDO_2_CLIENTE: '',
    RAZON_SOCIAL_CLIENTE: '',
    TELEFONO_CLIENTE: '',
    CELULAR_CLIENTE: '',
    DEPARTAMENTO_CLIENTE: '',
    MUNICIPIO_CLIENTE: '',
    BARRIO_CLIENTE: '',
    DIRECCION_VIA_PRINCIPAL: '',
    DIRECCION_DETALLE_CLIENTE: '',
    
    TIPO_VIA: '',
    DETALLE_VIA:'',
    PREFIJO_VIA: '',
    NUMERO: '',
    TIPO_VERTICAL: '',
    NUMERO_VERTICAL: '',
    TIPO_INTERIOR:'',
    DETALLE_INTERIOR: '',
    INTERIOR: '',
    TIPO_PREDIO: '',
    DESCRIPCION_PREDIO: '',

    INF_ADICIONAL_DIRECCION_CLIENTE: '',
    EMAIL_CLIENTE: a.Correo?.toUpperCase() ?? '',
    TIPO_INFO_PREDIAL: '',
    FICHA_CATASTRAL: '',
    TIPO_DE_RECIBO: a.RecibirFactElect === 'Si' ? 'SI' : 'NO',
    AUTORIZA_USO_DATOS: 'S',
    
    TIPO_DE_CONTACTO: '8',
    TIPO_DOCUMENTO_CONTACTO: a.TipoDoc?.toUpperCase() ?? '', //12-Tarjeta de identidad 13-Cédula de Ciudadanía 21-Tarjeta de Extranjería 22-Cédula de Extranjería 31-Número de Identificación Tributaria 41-Pasaporte 
    NUMERO_DOCUMENTO_CONTACTO: a.Identificacion ?? '',
    EXPEDICION_DOCUMENTO_CONTACTO: a.LugarExpDoc?.toUpperCase() ?? '',
    NOMBRE_1_CONTACTO: a.Nombre?.toUpperCase() ?? '',
    NOMBRE_2_CONTACTO: a.Nombre1?.toUpperCase() ?? '',
    APELLIDO_1_CONTACTO: a.Apellido?.toUpperCase() ?? '',
    APELLIDO_2_CONTACTO: a.Apellido1?.toUpperCase() ?? '',
    RAZON_SOCIAL_CONTACTO: a.RazonSoc?.toUpperCase() ?? '',
    DEPARTAMENTO_CONTACTO: a.DeptoCod ?? '',
    MUNICIPIO_CONTACTO: a.MunCod ?? '',
    DIRECCION_CONTACTO: a.Direccion?.toUpperCase() ?? '',
    EMAIL_CONTACTO: a.Correo?.toUpperCase() ?? '',
    CELULAR_CONTACTO_1: a.Celular ?? '',
    CELULAR_CONTACTO_2: '',
    TELEFONO_FIJO_CONTACTO: a.Telefono ?? '',
    EXTENSION_TELEFONO_FIJO_CONTACTO_1: '',
    TELEFONO_FIJO_CONTACTO_2: '',
    EXTENSION_TELEFONO_FIJO_CONTACTO_2: '',
    TELEFONO_FIJO_CONTACTO_3: '',
    EXTENSION_TELEFONO_FIJO_CONTACTO_3: ''    
  };
}